import React from 'react';
import { Link } from 'react-router-dom';
import { AnchorProps } from '@hvcgroep/design-system/dist/components/Button';

type Props = AnchorProps;

const CustomButtonLinkWrapper: React.FC<Props> = ({ href, ...props }) => {
  return (
    <Link to={href} {...props} />
  );
};

export default CustomButtonLinkWrapper;
